import api from "../Service/Api";
import { toastr } from "react-redux-toastr";

const trainingCentreBaseController = "api/trainers";
const skillsBaseController = "api/skills";


export const registerTrainingCenter = async (body) => {
  try {
    if (navigator.onLine) {
      const response = await api.post(`${trainingCentreBaseController}/create-trainer`, body);
      return response.data.data;
    }
  }
  catch (error) {
    console.log(error)
    toastr.error(error.response.data.errors, error.response.data.message)
    throw error;
  }
}

export const getAllActiveSkills = async (body) => {
  if (navigator.onLine === false) {
    toastr.error('No Internet Connection', 'Please try again');
  } else {
    try {
      const response = await api.get(`${skillsBaseController}/get-all-active-skills`, body);
      if (typeof response !== "undefined") {
        if (response.status === 200) {
          // toastr.success('Get All States', 'Success')
          return response.data.data;
        }
      } else {
        toastr.error("An Error occured", "Please try again")
      }
    } catch (ex) {
      toastr.error(ex.response.data.message, "")
    }
  }
}

